export default __webpack_public_path__ + "static/media/outer-footer-logo.3fe93389.svg";